import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../lib/api';
import { takeReturnTo } from '../lib/returnTo';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

/** Handles the one-tap "Sign in to CHIRE" button in the code email. */
export default function MagicLinkPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [error, setError] = useState('');
  const ran = useRef(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // `ran` makes this mount-only: `login()` changes the context value, which would
    // otherwise re-fire the effect and burn the (already-used) token a second time.
    if (ran.current) return;
    ran.current = true;

    if (!token) {
      setError('This sign-in link is missing its token.');
      return;
    }
    authAPI.verifyLink(token)
      .then(({ data }) => {
        login(data.user);
        toast.success(`Welcome${data.is_new_user ? ' to CHIRE' : ' back'}, ${data.user.name}!`);
        navigate(takeReturnTo() || (data.user.role === 'candidate' ? '/portal' : '/dashboard'), { replace: true });
      })
      .catch((e) => setError(e.response?.data?.detail || 'This sign-in link is no longer valid.'));
  }, [token, login, navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F1EAE1', padding: '1.5rem' }} data-testid="magic-link-page">
      <div style={{ background: '#fff', border: '1px solid #ECE7DE', borderRadius: 14, padding: '2rem', maxWidth: 420, width: '100%', textAlign: 'center' }}>
        <img src="/chire-logo-full.png" alt="CHIRE" style={{ height: 40, objectFit: 'contain', marginBottom: '1.25rem' }} />
        {error ? (
          <>
            <h1 style={{ fontFamily: 'Cabinet Grotesk', fontSize: '1.125rem', fontWeight: 700, color: '#002A38', marginBottom: '0.5rem' }}>Link expired</h1>
            <p data-testid="magic-link-error" style={{ fontSize: '0.875rem', color: '#64748B', lineHeight: 1.6, marginBottom: '1.5rem' }}>{error}</p>
            <Button data-testid="magic-link-retry" onClick={() => navigate('/login')}
              style={{ width: '100%', padding: '0.75rem', borderRadius: 999, fontWeight: 600, background: '#0076A3', color: '#fff' }}>
              Get a new code
            </Button>
          </>
        ) : (
          <p data-testid="magic-link-loading" style={{ fontSize: '0.875rem', color: '#64748B' }}>Signing you in…</p>
        )}
      </div>
    </div>
  );
}
